/*
 * Party Social — Dance Floor Calculator
 * Logic lives here because Shopify's page editor strips inline <script> tags.
 * Markup, CSS and the theme-asset image URLs come from sections/dancefloor-calculator.liquid.
 *
 * Sizing: 0.4 m2 of floor per person dancing at once. The stocked floors below
 * are the real rental sizes; the smallest one that covers the area is offered.
 *   Custom Black & White floor (from Oct):  16 x 8 ft, 16 x 16 ft, 20 ft round
 *   Infinity LED floor (available now):     4 x 4 m
 *
 * Photos: Party Social's own product images off the Shopify CDN take priority,
 * so the customer sees the floor they'd actually hire. Where there is no photo
 * yet (plain white, plain black) the CSS floor tile is shown instead.
 */
(function () {
  function init() {
    var root = document.getElementById('ps-dance-finder');
    if (!root || root.dataset.psReady === 'true') return;
    root.dataset.psReady = 'true';

    // A missing thumbnail should leave a clean gap, not a broken-image frame.
    root.querySelectorAll('[data-style-image]').forEach(function (img) {
      img.addEventListener('error', function () { img.style.visibility = 'hidden'; });
      img.addEventListener('load', function () { img.style.visibility = ''; });
    });

    const state = { step: 1, guests: 80, dance: 'lively', mood: 'elegant', style: 'white', shape: 'round' };
    const styleImages = JSON.parse(root.dataset.images || '{}');
    const moodDefaults = { elegant: 'white', modern: 'black', playful: 'checker', energy: 'led' };
    const styleCopy = {
      white: { label: 'white', copy: 'A soft, elegant focal point for weddings, refined dinners and romantic celebrations.', best: 'Elegant occasions', className: 'ps-white' },
      black: { label: 'black', copy: 'A polished, dramatic choice for evening events, galas and contemporary celebrations.', best: 'Modern evenings', className: 'ps-black' },
      checker: { label: 'checkered', copy: 'A graphic statement for fashion-led parties, birthdays and retro-inspired celebrations.', best: 'Playful parties', className: 'ps-checker' },
      led: { label: 'Infinity LED', copy: 'An immersive illuminated floor for launches, high-energy parties and nightclub-style celebrations.', best: 'High-energy events', className: 'ps-led' }
    };

    // Party Social's own product photography, straight off the Shopify CDN.
    // Only the checkered and LED floors are photographed. The plain white and
    // plain black finishes have no photo yet, so they fall through to the CSS
    // floor tile below rather than borrowing a black-and-white checkered shot.
    const CDN = 'https://cdn.shopify.com/s/files/1/0002/7112/2497/files/';
    const PHOTOS = {
      'checker':        CDN + 'Square_Checkered_Dancefloor.webp?v=1787141330',
      'checker-square': CDN + 'Square_Checkered_Dancefloor.webp?v=1787141330',
      'checker-round':  CDN + 'Round_black_white_dance_floor.webp?v=1787203370',
      'led':            CDN + 'dancefloor_1.jpg?v=1771406790',
      'led-square':     CDN + 'dancefloor_1.jpg?v=1771406790'
    };

    // Product photo first, theme asset second. Shopify resizes on the fly.
    function photoFor(style, shape, width) {
      const key = shape ? `${style}-${shape}` : style;
      const photo = PHOTOS[key] || PHOTOS[style];
      if (photo) return `${photo}&width=${width}`;
      return styleImages[key] || styleImages[style] || '';
    }

    // Where we have no photograph yet, show the CSS floor tile rather than a
    // stock photo of somebody else's dance floor. A theme asset that doesn't
    // exist still yields a URL, so the swap hangs off the image failing to
    // load, not just off an empty src.
    function paintStage(style, shape) {
      const stage = root.querySelector('.ps-stage');
      const img = root.querySelector('#ps-result-image');
      const info = styleCopy[style] || {};
      const src = photoFor(style, shape, 700);

      function showTile() {
        img.style.display = 'none';
        let tile = stage.querySelector('.ps-floor');
        if (!tile) {
          tile = document.createElement('span');
          stage.appendChild(tile);
        }
        tile.className = `ps-floor ${info.className || ''}${shape === 'round' ? ' is-round' : ''}`;
      }

      img.onerror = showTile;
      img.onload = function () {
        const tile = stage.querySelector('.ps-floor');
        if (tile) tile.remove();
        img.style.display = '';
      };

      if (!src) {
        img.removeAttribute('src');
        showTile();
        return;
      }
      img.src = src;
    }

    // Stocked floor sizes, smallest first. `area` is the floor area in square metres.
    const FLOORS = {
      round: [
        { label: '20 ft round (6.1 m across)', area: 29.2, price: 'AED 3,000' }
      ],
      square: [
        { label: '16 × 8 ft (4.9 × 2.4 m)', area: 11.9, price: 'AED 2,800' },
        { label: '16 × 16 ft (4.9 × 4.9 m)', area: 23.8, price: 'AED 3,000' }
      ]
    };
    const LED_FLOOR = { label: '4 × 4 m', area: 16, price: 'AED 5,000 incl. VAT' };

    function select(group, value) {
      state[group] = value;
      root.querySelectorAll(`[data-group="${group}"] button`).forEach((button) => {
        button.setAttribute('aria-pressed', button.dataset.value === value ? 'true' : 'false');
      });
      if (group === 'mood') {
        select('style', moodDefaults[value]);
      }
      if (group === 'style' && value === 'led') {
        select('shape', 'square');
      }
    }

    function renderStep() {
      root.querySelectorAll('.ps-step').forEach((panel) => {
        panel.hidden = Number(panel.dataset.step) !== state.step;
      });
      root.querySelector('#ps-step-label').textContent = `Step ${state.step} of 5`;
      root.querySelector('#ps-progress-fill').style.width = `${state.step * 20}%`;
      const roundButton = root.querySelector('[data-group="shape"] [data-value="round"]');
      const note = root.querySelector('#ps-shape-note');
      const ledOnly = state.style === 'led';
      roundButton.hidden = ledOnly;
      note.textContent = ledOnly
        ? 'The Infinity LED dance floor is available in a 4 × 4 metre square format.'
        : 'Round comes as a 20 ft floor (6.1 m across). Square and rectangular come as 16 × 8 ft or 16 × 16 ft.';
      if (state.step === 5) renderResult();
    }

    function renderResult() {
      const info = styleCopy[state.style];
      const danceRates = { light: .25, lively: .4, focused: .6 };
      const dancers = Math.max(4, Math.round(state.guests * danceRates[state.dance]));
      const areaNeeded = dancers * .4;

      const isLed = state.style === 'led';
      const options = isLed ? [LED_FLOOR] : (FLOORS[state.shape] || FLOORS.square);
      const match = options.find((option) => option.area >= areaNeeded);
      const floor = match || options[options.length - 1];
      const exceedsRange = !match;

      paintStage(state.style, state.shape);
      root.querySelector('#ps-result-title').textContent = `${state.shape === 'round' ? 'Round' : 'Square'} ${info.label} dance floor`;
      root.querySelector('#ps-result-copy').textContent = exceedsRange
        ? `About ${dancers} guests are likely to be dancing at once, which is more than our largest ${state.shape === 'round' ? 'round' : 'square'} floor comfortably holds. Our events team can look at the room and suggest the best arrangement.`
        : info.copy;
      root.querySelector('#ps-result-size').textContent = exceedsRange
        ? `Largest available: ${floor.label}`
        : floor.label;
      root.querySelector('#ps-result-price').textContent = floor.price;
      root.querySelector('#ps-result-best').textContent = info.best;
      root.querySelector('#ps-result-dancers').textContent = `About ${dancers} at once`;
      root.querySelector('#ps-result-guests').textContent = `${state.guests} guests`;
      root.querySelector('#ps-result-availability').textContent = isLed
        ? 'Available now'
        : 'For events after October 2026';
      root.querySelector('#ps-quote-button').textContent = exceedsRange
        ? 'Request a quote & layout review'
        : isLed ? 'Request a quote' : 'Book for your date';
      root.querySelector('#ps-cta-note').textContent = exceedsRange
        ? 'Our events team will review the room layout and recommend the best solution.'
        : isLed
          ? 'Rental price includes VAT; delivery, setup and collection are quoted separately.'
          : 'Price excludes delivery, setup and collection. Now accepting enquiries for events after October 2026.';
    }

    root.querySelectorAll('[data-group] button').forEach((button) => {
      button.addEventListener('click', () => select(button.closest('[data-group]').dataset.group, button.dataset.value));
    });
    root.querySelectorAll('[data-next]').forEach((button) => button.addEventListener('click', () => {
      state.guests = Math.max(10, Math.min(500, Number(root.querySelector('#ps-guests').value) || 80));
      state.dance = root.querySelector('#ps-dancing').value;
      state.step = Math.min(5, state.step + 1);
      renderStep();
    }));
    root.querySelectorAll('[data-back]').forEach((button) => button.addEventListener('click', () => {
      state.step = Math.max(1, state.step - 1);
      renderStep();
    }));
    root.querySelectorAll('[data-start]').forEach((button) => button.addEventListener('click', () => {
      state.step = 1;
      renderStep();
      root.querySelector('#ps-guests').focus();
    }));
    root.querySelector('#ps-quote-button').addEventListener('click', () => {
      window.location.href = root.dataset.quoteUrl || '/pages/event-rentals-party-social';
    });
    root.querySelectorAll('[data-style-image]').forEach((image) => {
      image.src = photoFor(image.dataset.styleImage, null, 400);
    });
    renderStep();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
  // Re-run when the section is re-rendered in the theme editor.
  document.addEventListener('shopify:section:load', function () {
    var root = document.getElementById('ps-dance-finder');
    if (root) root.dataset.psReady = '';
    init();
  });
})();
